import { CSSObjectWithLabel, StylesConfig } from 'react-select';

// Shared react-select styles that respect the app's dark/light theme via CSS variables.
// React-select applies inline styles that override SCSS class-based styles, so we must
// also set background/color via the styles prop to get correct dark mode colors.
export const darkModeSelectStyles: StylesConfig<any, any> = {
  menu: (base: CSSObjectWithLabel) => ({
    ...base,
    backgroundColor: 'var(--bs-dropdown-bg)',
    color: 'var(--bs-gray-700)',
  }),
  menuList: (base: CSSObjectWithLabel) => ({
    ...base,
    backgroundColor: 'var(--bs-dropdown-bg)',
  }),
  option: (base: CSSObjectWithLabel, state) => ({
    ...base,
    backgroundColor: state.isSelected || state.isFocused
      ? 'var(--bs-component-hover-bg)'
      : 'var(--bs-dropdown-bg)',
    color: state.isSelected || state.isFocused
      ? 'var(--bs-component-hover-color)'
      : 'var(--bs-gray-700)',
    ':active': {
      backgroundColor: 'var(--bs-component-hover-bg)',
    },
  }),
  control: (base: CSSObjectWithLabel) => ({
    ...base,
    backgroundColor: 'var(--bs-body-bg)',
    borderColor: 'var(--bs-gray-300)',
  }),
  singleValue: (base: CSSObjectWithLabel) => ({
    ...base,
    color: 'var(--bs-gray-700)',
  }),
  multiValue: (base: CSSObjectWithLabel) => ({
    ...base,
    backgroundColor: 'var(--bs-gray-300)',
  }),
  multiValueLabel: (base: CSSObjectWithLabel) => ({
    ...base,
    color: 'var(--bs-gray-700)',
  }),
  input: (base: CSSObjectWithLabel) => ({
    ...base,
    color: 'var(--bs-gray-700)',
  }),
  menuPortal: (base: CSSObjectWithLabel) => ({ ...base, zIndex: 9999 }),
};

// Merge caller-provided styles on top of the dark mode base styles.
// Caller styles take precedence so components can still customize individual parts.
export function mergeSelectStyles(
  overrides?: StylesConfig<any, any>
): StylesConfig<any, any> {
  if (!overrides) return darkModeSelectStyles;

  const merged: StylesConfig<any, any> = { ...darkModeSelectStyles };
  for (const key of Object.keys(overrides) as Array<keyof StylesConfig<any, any>>) {
    const base = darkModeSelectStyles[key] as ((b: any, s: any) => any) | undefined;
    const override = overrides[key] as ((b: any, s: any) => any) | undefined;
    if (base && override) {
      (merged as any)[key] = (b: any, s: any) => override(base(b, s), s);
    } else {
      (merged as any)[key] = override ?? base;
    }
  }
  return merged;
}
